// extracted by mini-css-extract-plugin
export default {"userpic":"lsf-userpic","userpic__username":"lsf-userpic__username"};
    if(module.hot) {
      // 1732531522885
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  